import { useState } from 'react';
import Reveal from '@/components/base/Reveal';

export default function DownloadCta() {
  const [notice, setNotice] = useState('');

  const handleAction = (label: string) => {
    setNotice(`${label}为演示入口，正式版本将在此提供下载与求助信息。`);
  };

  return (
    <section id="cta" className="w-full bg-background-50 pb-16 md:pb-20">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="relative rounded-lg overflow-hidden border border-primary-800">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20warm%20dark%20brown%20gradient%20background%20with%20faint%20topographic%20contour%20lines%20and%20paper%20grain%20texture%2C%20muted%20amber%20and%20clay%20accents%2C%20minimal%20artistic%20atmosphere%2C%20no%20people%2C%20no%20text%2C%20serious%20restrained%20documentary%20mood&width=1600&height=700&seq=mnhl-cta-01&orientation=landscape"
                alt="下载防骗自查手册 主题背景"
                title="缅北黑料 出境前防骗自查手册"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/85 to-foreground-950/60"></div>
            </div>

            <div className="relative px-6 md:px-12 py-12 md:py-16">
              <div className="max-w-2xl">
                <span className="text-xs md:text-sm tracking-[0.2em] text-primary-300">DOWNLOAD · 出发前自查</span>
                <h3 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
                  出发之前，先看完这份自查手册
                </h3>
                <p className="mt-4 text-sm md:text-base leading-7 md:leading-8 text-background-100/90">
                  我们把亲历者口述里反复提到的关键节点，整理成一份可打印的自查清单，涵盖招工核实、证件保管与联络预案。
                </p>

                <div className="mt-7 flex flex-col sm:flex-row gap-3">
                  <button
                    type="button"
                    onClick={() => handleAction('下载《出境前防骗自查手册》')}
                    className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-download-2-line text-lg"></i>
                    下载自查手册
                  </button>
                  <button
                    type="button"
                    onClick={() => handleAction('查看求助与通报指引')}
                    className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-background-100/40 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-customer-service-2-line text-lg"></i>
                    查看求助与通报指引
                  </button>
                </div>

                {notice && (
                  <div className="mt-5 inline-flex items-start gap-2 rounded-md bg-background-50/10 border border-background-100/25 px-4 py-3">
                    <span className="w-5 h-5 flex items-center justify-center text-primary-300">
                      <i className="ri-information-line"></i>
                    </span>
                    <p className="text-xs md:text-sm text-background-100/90 leading-6">{notice}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}